import { useCallback } from "react";
import { useAppNavigate } from "../global-hooks";
import { getAllPushMessage } from "../../actions/push-message";
import {
  resetPushMessage,
  setPushMessageBody,
  setPushMessageTitle,
  setPushMessagePage,
  setSearchText,
  setPushMessageImmediate,
  setPushMessageErrorMessage,
} from "../reducers/push-message.reducer";

export const useHandlePushMessageNavigateBack = (dispatch: Function) => {
  const navigate = useAppNavigate();
  const handleNavigateBack = useCallback(() => {
    dispatch(resetPushMessage());
    navigate("/push-message");
  }, [dispatch, navigate]);
  return handleNavigateBack;
};

export const useHandlePushMessageTitleChange = (dispatch: Function) => {
  const handleTitleChange = useCallback(
    (event: string) => {
      dispatch(setPushMessageTitle(event));
    },
    [dispatch]
  );
  return handleTitleChange;
};

export const useHandlePushMessageBodyChange = (dispatch: Function) => {
  const handleBodyChange = useCallback(
    (event: string) => {
      dispatch(setPushMessageBody(event));
    },
    [dispatch]
  );
  return handleBodyChange;
};


export const useHandlePushMessageImmediateChange = (dispatch: Function) => {
  const handleImmediateChange = useCallback(
    (value: boolean) => {
      dispatch(setPushMessageImmediate(value));
    },
    [dispatch]
  );
  return handleImmediateChange;
};

export const useHandlePushMessageDeciderChange = (setState: Function) => {
  const handleDecider = useCallback(
    (decider: boolean) => {
      setState((prevState: any) => ({ ...prevState, decider }));
    },
    [setState]
  );
  return handleDecider;
};

export const useHandlePushMessagePageChange = (
  dispatch: Function,
  setState: Function
) => {
  const handlePageChange = useCallback(
    (page: number) => {
      dispatch(setPushMessagePage(page));
      setState((prevState: any) => ({ ...prevState, searchTerm: false }));
    },
    [dispatch, setState]
  );
  return handlePageChange;
};

export const useHandlePushMessageSearchTextChange = (dispatch: Function) => {
  const handleSearchChange = useCallback(
    (message: string) => {
      dispatch(setSearchText(message));
    },
    [dispatch]
  );
  return handleSearchChange;
};

export const useHandleGetAllPushMessage = () => {
  const getPushMessages = useCallback(async () => {
    await getAllPushMessage();
  }, []);
  return getPushMessages;
};

export const useHandlePushMessageAlertMessageChange = (dispatch: Function) => {
  const handleAlertMessage = useCallback(
    (message: string | null) => {
      dispatch(setPushMessageErrorMessage(message));
    },
    [dispatch]
  );
  return handleAlertMessage;
};

export const useHandlePushMessageInputDeciderChange = (setState: Function) => {
  const handleDecider = useCallback(
    (inputButtonDisabler: boolean) => {
      setState((prevState: any) => ({ ...prevState, inputButtonDisabler }));
    },
    [setState]
  );
  return handleDecider;
};
